module.exports = __webpack_public_path__ + "img/Arrow down Icon - white.261419b1.svg";